// Cynhyrchwyd gan scripts/nodi-fersiwn.js
    export const FERSIWN_AP = '1.6.68';
    